// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import { getTravelType } from '../../forms/events/EventManager';
import '../../../styles/components/UserList.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import TravelListMobile from './TravelListMobile';

export default class TravelsList extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnClick } = this.props;
    handleOnClick(event.currentTarget.getAttribute('data-eventId'));
  };

  sortTravel = (a, b) => {
    if (
      getTravelType(a.flightType) === 'Arriving' &&
      getTravelType(b.flightType) === 'Returning'
    ) {
      return -1;
    }
    if (
      getTravelType(a.flightType) === 'Returning' &&
      getTravelType(b.flightType) === 'Arriving'
    ) {
      return 1;
    }
    return 0;
  };

  getIcon = type => {
    if (type === undefined || type === 'Flight') {
      return 'fas fa-plane-arrival';
    }
    if (type === 'Train') {
      return 'fas fa-subway';
    }
    if (type === 'Drive') {
      return 'fas fa-car';
    }
    return 'fas fa-walking';
  };

  getDestination = event => {
    let from = '';
    let to = '';
    const { startTime, endTime } = event;
    const startTimeZone = event.startTz;
    const endTimeZone = event.endTz;
    let locationTo = '';
    let locationFrom = event.eventLocationFrom
      ? event.eventLocationFrom?.address
      : event.passengers.locationFrom?.address;
    if (!locationFrom) {
      locationFrom = '';
    }
    from = `${moment(startTime)
      .tz(startTimeZone)
      .format('MM/DD/YYYY hh:mm A z')} - ${locationFrom}`;
    if (event.travelType === undefined || event.travelType === 'Flight') {
      locationTo = event.eventLocationTo
        ? event.eventLocationTo?.address
        : event.passengers.locationTo?.address;
      if (!locationTo) {
        locationTo = '';
      }
      to = event.timeTBD
        ? `TBD ${locationTo}`
        : `${moment(endTime)
            .tz(endTimeZone)
            .format('MM/DD/YYYY hh:mm A z')} - ${locationTo}`;
    }
    if (event.timeTBD) {
      from = `TBD ${locationFrom} `;
    }
    return { from, to };
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { events } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const sortedEvents = events.sort(this.sortTravel);
    if (isMobileResolution()) {
      return (
        <TravelListMobile
          events={sortedEvents}
          handleOnClick={this.handleOnClick}
          getDestination={this.getDestination}
        />
      );
    }
    return (
      <div className='eventlist'>
        <Table hover>
          <thead>
            <tr>
              <th />
              <th>From</th>
              <th>To</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            {sortedEvents.map(event => {
              const { from, to } = this.getDestination(event);
              return (
                <tr
                  key={event.eventId}
                  data-eventid={event.eventId}
                  className='listrow'
                  onClick={this.handleOnClick}
                >
                  <td style={{ width: '10%' }}>
                    <i
                      className={this.getIcon(event.travelType)}
                      style={{ paddingRight: '5px' }}
                    />
                  </td>
                  <td style={{ width: '30%' }}>{from}</td>
                  <td style={{ width: '30%' }}>{to}</td>
                  <td style={{ width: '30%' }}>
                    {getTravelType(event.flightType)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}
